import React, { useState, useEffect } from "react";
import {
  VisibleFluorescenceCaptureProperty,
  UltravioletCaptureProperty,
  UltravioletFluorescenceCaptureProperty,
  VisibleCaptureProperty,
} from "../../../Model/CaptureProfile";
import { Exposure } from "../../../Model/ImagerCapabilities";
import ImagerFeatureControlSlider from "../ImagerFeatureControlSlider";
import EOpticAndCameraFeature from "../../../Model/EOpticAndCameraFeature";
import { BaseControl, FeatureLabel, ValueTextBox, UnitLabel } from "../ImagerFeatureControls";

type ExposureControlProps = {
  captureProperty:
    | VisibleCaptureProperty
    | VisibleFluorescenceCaptureProperty
    | UltravioletCaptureProperty
    | UltravioletFluorescenceCaptureProperty;
  onChange: (value: { exposure: number }) => void;
  disabled: boolean;
  exposure: Exposure;
};

export function ExposureControl({ exposure, captureProperty, onChange, disabled }: ExposureControlProps) {
  if (captureProperty.exposure == null) {
    throw new Error("Capture profile exposure is null");
  }

  const [tbValue, setTbValue] = useState(captureProperty.exposure);
  // const halfTick = (exposure.maxExposure - exposure.minExposure) / 2;
  useEffect(() => {
    if (captureProperty.exposure == null) {
      throw new Error("Capture profile exposure is null");
    }
    setTbValue(captureProperty.exposure);
  }, [captureProperty.exposure]);

  return (
    <BaseControl key={EOpticAndCameraFeature.Exposure} id={EOpticAndCameraFeature.Exposure} disabled={disabled}>
      <FeatureLabel disabled={disabled}>{"Exposure Time:"}</FeatureLabel>
      <ImagerFeatureControlSlider
        disabled={disabled}
        value={captureProperty.exposure}
        min={exposure.minExposure}
        max={exposure.maxExposure}
        onValueChanged={(value: number) =>
          onChange({
            exposure: value,
          })
        }
        onHandleDraged={(value: number) => setTbValue(value)}
        step={0.1}
        style={{
          marginLeft: 5,
          flexGrow: 1,
        }}
      />
      <ValueTextBox
        min={exposure.minExposure}
        max={exposure.maxExposure}
        disabled={disabled}
        value={tbValue}
        onValueChanged={(id: string, value: number) =>
          onChange({
            exposure: value,
          })
        }
        id={EOpticAndCameraFeature.Exposure}
      />
      <UnitLabel disabled={disabled}>ms</UnitLabel>
    </BaseControl>
  );
}
